import { render, staticRenderFns } from "./CrudDinamico.vue?vue&type=template&id=7405980b"
import script from "./CrudDinamico.vue?vue&type=script&lang=js"
export * from "./CrudDinamico.vue?vue&type=script&lang=js"
import style0 from "./CrudDinamico.vue?vue&type=style&index=0&id=7405980b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports